export const MESSAGE_PAGE_PATH = '/message/list'
